import {createContext} from 'react';

const AnswersContext =  createContext({})

export default AnswersContext;